import React from 'react';
import ArrowLeft from 'svg/ArrowLeft';
import { ButtonText } from 'components/Button';
import classNames from 'styles/utils/classNames';

type HeaderProps = {
  title: string;
  showBack?: boolean;
  showBackAction?: () => void;
  cta?: string;
  className?: string;
  ctaClassName?: string;
};

const Header: React.FC<HeaderProps> = ({
  title,
  showBack,
  showBackAction,
  cta,
  className,
  ctaClassName,
}) => {
  return (
    <div className={classNames('flex flex-col gap-6', className)}>
      <h2 className="typography-product-heading-mobile flex flex-row items-center gap-4 text-color-text-brand dark:text-color-text-brand">
        {showBack && (
          <ButtonText className="shrink-0" type="button" onClick={showBackAction}>
            <ArrowLeft className="h-5 w-5 text-color-text-brand dark:text-color-text-brand" />
          </ButtonText>
        )}
        {title}
      </h2>
      {!!cta && (
        <p
          className={classNames(
            'typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
            ctaClassName,
          )}
        >
          {cta}
        </p>
      )}
    </div>
  );
};

export default Header;
